import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'
import {Spinner, Image} from 'react-bootstrap'
import logo from '../assets/emedhub.svg'
import failedLogo from '../assets/success.png'
import SuccessLogo from '../assets/failed.png'
import './payment.css'
import { Constants } from "../utils/constants";


function PaymentResponse() {

  const { search } = useLocation()
  const[loading, setLoading] = useState(true)
  const[status, setstatus] = useState("")

  console.log("Query:",search)

  useEffect(()=> {
    let url = Constants.PAYMENT_RESPONSE_GET;
    fetch(url + search,{
      method:"GET",
      headers:{
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(data => { 
      console.log(data)
      setLoading(false)
      setstatus(data.status)
    });

  },[])


  return (
    <div>
      <Image style={{height:'60px', width:'100%', marginTop:'50px', display:'flex', marginBottom:'50px' }} src={logo} rounded />
      {loading? 
      <div className="center">
        <Spinner animation="border" /> 
        <br />
        <br />
        <span style={{fontSize:20}}>Please wait....</span>
      </div>
      :
      <div className="center">
      {status === "fail" ?
      <div style={{ height:'300px', border:'2px solid grey', borderRadius:'10px', backgroundColor:'lightyellow'}}>
        <h6 style={{display:'flex', justifyContent:'center',width:'250px', height:'75px', paddingTop:'25px',paddingBottom:'25px', fontSize:'25px', color:'red', backgroundColor:'lightblue',borderRadius:'10px 10px 0px 0px', marginBottom:'20px', fontStyle:'italic'}}>Payment Failed</h6>
        <Image style={{height:'70px'}} src={failedLogo} roundedCircle/>
        <p style={{marginTop:'30px', fontStyle:'italic'}}>Your transaction get failed !</p>
        <p style={{ fontStyle:'italic'}}>Please try again later</p>
      </div>
      :
      <div style={{ height:'300px', border:'2px solid grey', borderRadius:'10px', backgroundColor:'lightyellow'}}>
      <h6 style={{display:'flex', justifyContent:'center',width:'250px', height:'75px', paddingTop:'25px',paddingBottom:'25px', fontSize:'25px', color:'green', backgroundColor:'lightblue',borderRadius:'10px 10px 0px 0px', marginBottom:'20px', fontStyle:'italic'}}>Payment Success</h6>
        <Image style={{height:'70px'}} src={SuccessLogo} roundedCircle/>
        <p style={{marginTop:'30px', fontStyle:'italic'}}>Your transaction completed</p>
      </div>

      }
      </div>
      }

    </div>
  );
}

export default PaymentResponse;
